(function () {
  'use strict';

  // Publishes the live height of the stacked sticky top bars as --ls-sticky-h on
  // <html>. Sticky rails ("On this page", the help chapter tree, the release year
  // bands, the download filter toolbar) park below that instead of hard-coding a
  // pixel offset, which goes stale as soon as the stack changes height: the
  // navbar shrinks 104px -> 50px on scroll (go-to-top.js) and the product sub-nav
  // grows 43px -> 98px when its compact CTA bar slides in (products/base.html).
  var bars = Array.prototype.slice.call(
    document.querySelectorAll('.navbar.sticky-top, .product-tabs-nav')
  );
  if (!bars.length) {
    return;
  }

  var root = document.documentElement;
  var last = -1;

  function measure() {
    var height = bars.reduce(function (sum, bar) {
      return sum + bar.offsetHeight;
    }, 0);
    if (height === last) {
      return;
    }
    last = height;
    root.style.setProperty('--ls-sticky-h', height + 'px');
  }

  measure();

  var observer = new ResizeObserver(measure);
  bars.forEach(function (bar) {
    // border-box, not the default content-box: the navbar shrinks by dropping
    // padding, which leaves its content box untouched, so a content-box
    // observation never fires and the stack is measured 54px too tall.
    observer.observe(bar, { box: 'border-box' });
  });
})();
